import { TenantUsersApiFactory, V1TenantUser, V1Website } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { TenantUser, Website } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'

function createWebsites(rawWebsites?: V1Website[]): Website[] {
  if (!rawWebsites) return [] as Website[]

  return rawWebsites.map((w: V1Website): Website => {
    return new Website({
      id: w.id,
      displayName: w.displayName,
      url: w.url,
      passcode: w.passcode,
      useTenantIdPass: w.useTenantIdPass,
    })
  })
}

function createTenantUsers(rawTenantUsers?: V1TenantUser[]): TenantUser[] {
  if (!rawTenantUsers) return [] as TenantUser[]

  return rawTenantUsers.map((wu: V1TenantUser): TenantUser => {
    return new TenantUser({
      id: wu.id,
      companyId: wu.companyId,
      name: wu.name,
      mail: wu.mail,
      websites: createWebsites(wu.websites)
    })
  })
}

export const NewTenantUsersApiFunc = () => {
  const webAdapter = TenantUsersApiFactory(undefined, api.defaults.baseURL, api)

  return {
    listTenantUsers: async (companyId: string, filter?: string, page?: number): Promise<ApiResponse<ListResponse<TenantUser>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listTenantUsers(companyId, filter, page)
        data = createTenantUsers(res.data.tenantUsers)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as TenantUser[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    },

    getTenantUser: async (companyId: string, tenantUserId: string): Promise<ApiResponse<TenantUser>> => {
      let data, err

      try {
        const res = await webAdapter.getTenantUser(companyId, tenantUserId)
        data = createTenantUsers([res.data])[0]
      } catch (e) {
        data = new TenantUser()
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    createTenantUser: async (companyId: string, tenantUser: TenantUser): Promise<ApiResponse<TenantUser | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.createTenantUser(companyId, {data: tenantUser})
        data = createTenantUsers([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    updateTenantUser: async (companyId: string, tenantUserId: string, tenantUser: TenantUser): Promise<ApiResponse<TenantUser | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updateTenantUser(companyId, tenantUserId, {data: tenantUser})
        data = createTenantUsers([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    deleteTenantUser: async (companyId: string, tenantUserId: string): Promise<ApiResponse<void>> => {
      let data, err

      try {
        await webAdapter.deleteTenantUser(companyId, tenantUserId)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    }
  }
}
